import React from "react";

import NoOptions from "./no-options";

import { Select } from "../../inputs";

const AddBullet = ({ add, definitions, options }) => {
    return (
        <div className="product-compare-row" style={{ gridTemplateColumns: "150px repeat(1, 1fr)" }}>
            <div className="row-header">Add Feature Bullet</div>
            <div className="input-group -no-margin">
                {options.length > 0 && <Select key="addFeatureBullet" name="addFeatureBullet" options={options} updateOnChange={add} stopAutoSelect={true} />}
                {options.length < 1 && <NoOptions definitions={definitions} />}
            </div>
        </div>
    );
};

export default AddBullet;
